import { useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom-v5-compat";
import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import useHelp from "../../help/useHelp";
import { articlePath } from "../../help/catalogue";
export default function DocsSidebar({ onMobileClose, openMobile }) {
  const { pathname } = useLocation();
  const { articles, brand } = useHelp();
  useEffect(() => {
    if (openMobile) onMobileClose();
  }, [pathname]); // Close only after navigation.
  const content = (
    <Box component="nav" aria-label="Help Centre" sx={{ p: 2 }}>
      <ListItemButton
        component={RouterLink}
        to="/docs"
        selected={pathname === "/docs"}
      >
        <ListItemText primary="All guides" />
      </ListItemButton>
      {[...new Set(articles.map((a) => a.category))].map((category) => (
        <Box key={category} sx={{ mt: 3 }}>
          <Typography variant="overline" color="text.secondary">
            {category}
          </Typography>
          <List disablePadding>
            {articles
              .filter((a) => a.category === category)
              .map((a) => (
                <ListItemButton
                  key={a.slug}
                  component={RouterLink}
                  to={articlePath(a)}
                  selected={pathname === articlePath(a)}
                >
                  <ListItemText primary={a.title} />
                </ListItemButton>
              ))}
          </List>
        </Box>
      ))}
      {brand.supportUrl && (
        <ListItemButton
          component="a"
          href={brand.supportUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ mt: 4 }}
        >
          <ListItemText primary="Contact support" />
        </ListItemButton>
      )}
    </Box>
  );
  return (
    <>
      <Drawer
        open={openMobile}
        onClose={onMobileClose}
        sx={{ display: { xs: "block", lg: "none" } }}
        PaperProps={{ sx: { width: 256, pt: 8 } }}
      >
        {content}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{ display: { xs: "none", lg: "block" } }}
        PaperProps={{
          sx: { width: 256, top: 64, height: "calc(100% - 64px)" },
        }}
      >
        {content}
      </Drawer>
    </>
  );
}
